import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/zsevic.github.io/zsevic.github.io/node_modules/gatsby-theme-chronoblog/src/components/page/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="1-on-1 Software Engineering Consultation" mdxType="SEO" />
    <h1 {...{
      "id": "1-on-1-software-engineering-consultation"
    }}>{`1-on-1 Software Engineering Consultation`}</h1>
    <p>{`Get practical advice and solutions tailored to your project, career, or technical challenges.`}</p>
    <h2 {...{
      "id": "what-we-can-discuss"
    }}>{`What We Can Discuss`}</h2>
    <ul>
      <li parentName="ul">{`Node.js and TypeScript`}</li>
      <li parentName="ul">{`Backend Architecture`}</li>
      <li parentName="ul">{`AI Engineering`}</li>
      <li parentName="ul">{`Code Reviews`}</li>
      <li parentName="ul">{`Performance and Scalability`}</li>
      <li parentName="ul">{`Career Advice`}</li>
      <li parentName="ul">{`Technical Interview Preparation`}</li>
      <li parentName="ul">{`Project Planning`}</li>
    </ul>
    <h2 {...{
      "id": "whats-included"
    }}>{`What's Included`}</h2>
    <ul>
      <li parentName="ul">{`45-minute Google Meet session`}</li>
      <li parentName="ul">{`Personalized guidance based on your goals`}</li>
      <li parentName="ul">{`Q&A on any software engineering topic`}</li>
      <li parentName="ul">{`Actionable recommendations and next steps`}</li>
    </ul>
    <h2 {...{
      "id": "pricing"
    }}>{`Pricing`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Early Supporter`}</strong>{`: $50 (first 10 bookings)`}</li>
      <li parentName="ul"><strong parentName="li">{`Standard`}</strong>{`: $75 (ongoing)`}</li>
    </ul>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How It Works`}</h2>
    <ol>
      <li parentName="ol">{`Become a GitHub sponsor using one of the consultation tiers.`}</li>
      <li parentName="ol">{`Use the booking link included in the sponsor welcome message.`}</li>
      <li parentName="ol">{`Share a short description of what you'd like to discuss.`}</li>
      <li parentName="ol">{`Join the Google Meet session at your scheduled time.`}</li>
    </ol>
    <h2 {...{
      "id": "book-your-consultation"
    }}>{`Book Your Consultation`}</h2>
    <p>{`To book a consultation,
you will need to `}<a parentName="p" {...{
        "href": "https://github.com/sponsors/zsevic?frequency=one-time&sponsor=zsevic"
      }}>{`become a GitHub sponsor`}</a>{`.
Once your sponsorship is complete,
you will receive a welcome message with a booking link to schedule your session.`}</p>
    <p>{`I look forward to helping you solve technical challenges and achieve your goals.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      